module.exports = __webpack_public_path__ + "img/success.d2a45afd.svg";